module.exports = __webpack_public_path__ + "img/rosemount-3308-wireless-gwr-transmitter-1-single-flex.d99b264f.png";